import React from 'react'
import { BaileyStill } from '../../../../agent/bailey/BaileyAvatar'
import { useSavedLook } from '../../../../agent/bailey/lookStore'
import { SparkIcon } from './icons'

// Bailey, small: head and shoulders (in the owner's chosen look) in a soft
// circle with a ring that turns while Bailey is working. `orb` is the
// compact mark for tight spaces (a chip, a button).
const BaileyMark = ({ size = 44, variant = 'portrait', thinking = false, className = '' }) => {
  const look = useSavedLook()
  if (variant === 'orb') {
    return (
      <span className={`sx-bmark sx-bmark--orb${thinking ? ' is-thinking' : ''} ${className}`} style={{ width: size, height: size }} aria-hidden>
        <SparkIcon size={Math.round(size * 0.5)} />
      </span>
    )
  }
  return (
    <span className={`sx-bmark sx-bmark--portrait${thinking ? ' is-thinking' : ''} ${className}`} style={{ width: size, height: size }} aria-hidden>
      <span className="sx-bmark-disc">
        <BaileyStill appearance={look || undefined} face />
      </span>
    </span>
  )
}

export default BaileyMark
